// src/api/redirectReviews.js
// Redirect Review Queue — ambiguous scraper redirects awaiting an
// adopt/retire/dismiss decision. Backend: backend/scrapers/routes.py
// §REDIRECT REVIEW QUEUE (migration 184). See docs/features/scraper.md
// §Redirect Review Queue for the endpoint contract.
import { api } from './client';

export function listRedirectReviews(status) {
  const params = {};
  if (status) params.status = status;
  return api.get('/api/scrapers/redirect-reviews', { params }).then((r) => r.data);
}

export function adoptRedirectReview(id) {
  return api.post(`/api/scrapers/redirect-reviews/${id}/adopt`).then((r) => r.data);
}

export function retireRedirectReview(id) {
  return api.post(`/api/scrapers/redirect-reviews/${id}/retire`).then((r) => r.data);
}

export function dismissRedirectReview(id) {
  return api.post(`/api/scrapers/redirect-reviews/${id}/dismiss`).then((r) => r.data);
}
